export default "__VITE_ASSET__DMROM2AF__"